import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/solid';
import React, { useState } from 'react';
import { StringTranslations } from '@services';

type Props = {
  currentYear: number
  lang: string
  showYears: {
    year: number
    isCurrent: boolean,
  }[]
  stringTranslations: StringTranslations,
  selectYear: (year: number) => void;
}

function ChdTvDropdown({
  currentYear, lang, showYears, stringTranslations, selectYear,
}: Props) {
  const clickSelectYear = (year: number): void => {
    selectYear(year);
  };

  const [customOpen, setCustomOpen] = useState(false);

  const handleClick = () => {
    if (customOpen) {
      setCustomOpen(false);
    } else {
      setCustomOpen(true);
    }
  };

  const handleOpen = () => {
    setCustomOpen(true);
  };

  const handleClose = () => {
    setCustomOpen(false);
  };

  return (
    <Menu as="div" className="relative block">
      <Menu.Button
        onKeyDown={handleClick}
        onClick={handleClick}
        onMouseEnter={handleOpen}
        onMouseLeave={handleClose}
        tabIndex={0}
        className="flex justify-center items-center w-[169px] h-[47px] uppercase font-semibold text-[14px] tracking-widest leading-[26px] my-1 px-4 text-[#fff] bg-[#000] border-chdBlue-light hover:border-chdBlue-light border-2"
      >
        <p>{`${stringTranslations.year[lang]} ${currentYear}`}</p>
        <ChevronDownIcon className="w-[20px] ml-[10px] stroke-2" />
      </Menu.Button>

      <Transition
        show={customOpen}
        className="absolute p-2 z-20 shadow bg-[#000] rounded-box w-[169px] right-0 text-[14px]"
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          onClick={handleClick}
          onMouseEnter={handleOpen}
          onMouseLeave={handleClose}
          static
          className="mt-[-14px] pt-2"
        >
          {showYears.map((item: any) => (
            <Menu.Item key={item.year}>
              {({ active }) => (
                <div
                  onClick={() => clickSelectYear(item.year)}
                  role="presentation"
                  className={`cursor-pointer p-3 hover:text-chdGreen-light rounded-md hover:bg-stone-800/[.5] ${active && 'bg-stone-500/[.5]'}`}
                >
                  {item.year}
                </div>
              )}
            </Menu.Item>
          ))}
        </Menu.Items>
      </Transition>
    </Menu>
  );
}

export default ChdTvDropdown;
